import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./styles.styl";

interface Props {
  prefix?: string;
  colormap: [[number, number, number]];
  markers: number[];
  unitLabel: string;
}
/**
 * @todo scalebar의 크기를 파라미터로 입력받도록 수정 필요
 * @param props
 */
const ColorscaleBar: React.FC<Props> = (props: Props) => {
  const { prefix = "", colormap, markers, unitLabel = "" } = props;
  return (
    <div className={classNames(prefix, "colorscalebar--wrapper")}>
      {/* <label className={classNames(prefix, "colorscalebar--top-label")}>
        50%
      </label> */}
      <div className={classNames(prefix, "colorscalebar--colormap")}>
        <div className={classNames(prefix, "colorscalebar--colormap-bar")}>
          <svg>
            <defs>
              <linearGradient
                id="colorscalebar--colormap-bar-gradient"
                gradientTransform="rotate(90)"
              >
                {!!colormap &&
                  colormap
                    .slice(0)
                    .reverse()
                    .map((item: any, i: number) => {
                      return (
                        <stop
                          key={`Colormap-Gradient-${i}`}
                          offset={`${(100 / colormap.length) * i}%`}
                          stopColor={`rgb(${item[0]}, ${item[1]}, ${item[2]})`}
                        />
                      );
                    })}
              </linearGradient>
            </defs>
            <rect
              fill="url('#colorscalebar--colormap-bar-gradient')"
              x="0"
              y="0"
              height="100%"
              width="100%"
            />
          </svg>
        </div>
        <div className="colorscalebar--legend">
          {!!markers &&
            markers.map((value, i) => {
              if (i === 0) {
                return (
                  <div
                    key={`Colormap-Marker-Key-${i}`}
                    className={classNames(prefix, "colorscalebar--marker")}
                    style={{ top: "0px" }}
                  >
                    {value}
                  </div>
                );
              } else if (i === markers.length - 1) {
                return (
                  <div
                    key={`Colormap-Marker-Key-${i}`}
                    className={classNames(prefix, "colorscalebar--marker")}
                    style={{ bottom: "0px" }}
                  >
                    {value}
                  </div>
                );
              }
              return (
                <div
                  key={`Colormap-Marker-Key-${i}`}
                  className={classNames(prefix, "colorscalebar--marker")}
                  style={{
                    top: `${(100 / markers.length) * i}%`,
                  }}
                >
                  {value}
                </div>
              );
            })}
        </div>
      </div>
      <label className={classNames(prefix, "colorscalebar--bottom-label")}>
        {unitLabel}
        {/*  */}
      </label>
    </div>
  );
};

export default ColorscaleBar;
